import React from 'react';
import moment from 'moment';
import { MessageSquare, Clock } from 'lucide-react';

export const CommunicationEvent = ({ event, OnRedirect = {} }) => {
  const setting = JSON.parse(localStorage.getItem("settings"));
  const timeFormat = setting?.regionalSettings?.timeFormat ? (setting?.regionalSettings?.timeFormat.trim().toLowerCase() === "hh:mm a" ? "h:mm A" : "HH:mm") : "HH:mm";

  const getCategoryText = () => {
    switch (event.category) {
      case 0: return 'Initiating';
      case 1: return 'Planning';
      case 2: return 'Monitoring';
      case 3: return 'Governance';
      case 4: return 'Steering Co';
      case 5: return 'Cost Management';
      case 6: return 'Risk Management';
      case 7: return 'Resource Management';
      case 8: return 'Closing';
      default: return '';
    }
  };

  const formatTime = () => {
    const start = moment(event.startTime);
    const end = moment(event.endTime);

    if (event.isAllDay) {
      return 'All Day';
    }

    return `${start.format(timeFormat)} - ${end.format(timeFormat)}`;
  };

  const getDuration = () => {
    if (event.isAllDay) return null;

    const start = moment(event.startTime);
    const end = moment(event.endTime);
    const duration = moment.duration(end.diff(start));

    if (duration.hours() > 0) {
      return `${duration.hours()}h ${duration.minutes()}m`;
    }
    return `${duration.minutes()}m`;
  };

  const handleRedirection = () => {
    if (OnRedirect) {
      OnRedirect();
    }
  };
  
  return (
    <div
      onClick={() => { handleRedirection() }}
      className="communication-event">
      <div className="communication-event__header">
        <div className="communication-event__icon">
          <MessageSquare />
        </div>
        <div className="communication-event__title-section">
          <h6 className="communication-event__title">{event.title}</h6>
          {event.project && (
            <span className="communication-event__project">{event.project.name}</span>
          )}
        </div>
        <div className="communication-event__badges">
          <span className="communication-event__badge communication-event__badge--category">
            {getCategoryText()}
          </span>
          {event.isRecurring && (
            <span className="communication-event__badge communication-event__badge--recurring">
              Recurring
            </span>
          )}
        </div>
      </div>

      <div className="communication-event__details">
        <div className="communication-event__time">
          <span className="inline-flex items-center justify-start gap-1">
            <Clock size={12} /> {formatTime()} {getDuration() && <span className="communication-event__duration"> ({getDuration()})</span>}
          </span>
        </div>

        {event.client && (
          <div className="communication-event__client">
            <strong>Client:</strong> {event.client.name}
          </div>
        )}

        {event.portfolio && (
          <div className="communication-event__portfolio">
            <strong>Portfolio:</strong> {event.portfolio.name}
          </div>
        )}

        {event.program && (
          <div className="communication-event__program">
            <strong>Program:</strong> {event.program.name}
          </div>
        )}

      </div>
    </div>
  );
};